module.exports = __webpack_public_path__ + "img/logo-school-3.7b8fe19d.png";